import {getAllDynamicTagsRtnService} from '@/services/notificationsService'
import {getAllDynamicTagsRtnRequest, getAllDynamicTagsRtnResponse} from '@/types/DynamicTags'

export async function getAllDynamicTagsRtnUseCase(
  params: getAllDynamicTagsRtnRequest,
  signal?: AbortSignal
): Promise<getAllDynamicTagsRtnResponse> {
  return getAllDynamicTagsRtnService(params, signal)
}
